import { ThreeCanvas } from "@remotion/three";
import { ReactNode } from "react";
import { AbsoluteFill, useCurrentFrame, useVideoConfig } from "remotion";
import { BRAND } from "./theme";

/**
 * The shared 3D stage: a ThreeCanvas with a slow frame-driven camera drift
 * (so nothing is ever static), a two-point neon lighting rig, and a radial
 * gradient backdrop. Children render inside the 3D scene.
 *
 * Captions/HTML overlays must be rendered as SIBLINGS of <Stage> (outside the
 * canvas), since they are DOM, not 3D.
 */
export const Stage: React.FC<{
  children: ReactNode;
  /** Camera drift amplitude (0 = locked). */
  orbit?: number;
  cameraZ?: number;
}> = ({ children, orbit = 0.12, cameraZ = 7 }) => {
  const frame = useCurrentFrame();
  const { width, height, durationInFrames } = useVideoConfig();
  const t = frame / Math.max(1, durationInFrames);
  const camX = Math.sin(t * Math.PI * 2) * orbit * 3;
  const camY = Math.cos(t * Math.PI * 2) * orbit * 1.5 + 0.4;

  return (
    <AbsoluteFill
      style={{
        background: `radial-gradient(120% 100% at 50% 0%, ${BRAND.space1}, ${BRAND.space0})`,
      }}
    >
      <ThreeCanvas
        width={width}
        height={height}
        camera={{ position: [camX, camY, cameraZ], fov: 50 }}
        gl={{ antialias: true }}
      >
        <ambientLight intensity={0.35} />
        <pointLight position={[6, 8, 8]} intensity={120} color={BRAND.cyan} />
        <pointLight
          position={[-8, -4, 6]}
          intensity={90}
          color={BRAND.violet}
        />
        {children}
      </ThreeCanvas>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
